// extracted by extract-css-chunks-webpack-plugin
module.exports = {"HeroHeader":"HeroHeader","HeroHeader__heading":"HeroHeader__heading","HeroHeader__description":"HeroHeader__description"};